export default "__VITE_ASSET__89573beb__"